import { isUserUsingNorwegianLanguageOnProject } from '../../i18n/project-i18n-model';

const norwegianErrorMessages = {
    incomplete_card_number: 'Vennligst skriv inn et fullstendig kortnummer.',
    invalid_number: 'Kortnummeret er ikke gyldig.',
    incomplete_expiry: 'Vennligst skriv inn en gyldig utløpsdato.',
    invalid_expiry: 'Utløpsdatoen er ikke gyldig.',
    incomplete_cvc: 'Vennligst skriv inn sikkerhetskoden.',
    incomplete_postal_code: 'Vennligst skriv inn postnummeret ditt.',
    required: 'Dette feltet er påkrevd.',
    card_declined: 'Kortet ditt ble avvist. Prøv et annet kort eller ta kontakt med banken din.',
};

export const getCardErrorFromStripeError = (project, error) => {
    if (isUserUsingNorwegianLanguageOnProject(project)) {
        return norwegianErrorMessages[error.code] || error.message;
    } else {
        return error.message;
    }
};
